/**
 * RegistrationIntakeStatusService
 * Service for managing registration intake statuses
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for registration intake status CRUD operations
 */
export class RegistrationIntakeStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? RegistrationIntakeStatusService.DEFAULT_SERVICE_PATH,
            basePath: RegistrationIntakeStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
RegistrationIntakeStatusService.DEFAULT_SERVICE_PATH = 'ac-courses';
RegistrationIntakeStatusService.BASE_PATH = 'api/registration-intake-statuses';
//# sourceMappingURL=RegistrationIntakeStatusService.js.map